<template>
    <div class="main">
        <c-panel title="INSCRIÇÕES" titleIcon="fas fa-user-plus">
            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="6"><el-input v-model="filtro.nome" placeholder="Nome do candidato" @keyup.native.enter="carregar"></el-input></el-col>
                <el-col :xs="12" :sm="4"><el-input v-model="filtro.cpf" placeholder="CPF" @keyup.native.enter="carregar"></el-input></el-col>
                <el-col :xs="12" :sm="4"><el-input v-model="filtro.protocolo" placeholder="Protocolo" @keyup.native.enter="carregar"></el-input></el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.situacao" clearable placeholder="Situação" style="width: 100%;" @change="carregar">
                        <el-option v-for="s in situacoes" :key="s" :value="s" :label="rotulo(s)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="5" class="u-text-right">
                    <el-button icon="el-icon-search" @click="carregar">BUSCAR</el-button>
                    <router-link v-if="podeEscrever" to="/admin/inscricao/cadastro" class="btn-new-register u-ml-10">
                        <el-button type="primary">NOVA</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="u-text-center" style="width: 50px;">Pos.</th>
                            <th style="width: 130px;">Protocolo</th>
                            <th>Candidato</th>
                            <th class="hidden-mobile">Responsável</th>
                            <th class="hidden-mobile">Escolas</th>
                            <th class="u-text-center" style="width: 70px;">Pontos</th>
                            <th class="u-text-center" style="width: 110px;">Situação</th>
                            <th class="u-text-center" style="width: 60px;">Canal</th>
                            <th class="u-text-center" style="width: 110px;">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="i in items" :key="i.id">
                            <td class="u-text-center">{{ i.classificacao || '—' }}</td>
                            <td>{{ i.protocolo }}</td>
                            <td>{{ i.nome }}</td>
                            <td class="hidden-mobile">{{ i.nome_responsavel }}</td>
                            <td class="hidden-mobile">
                                <span v-for="e in (i.escolas || [])" :key="e.id" class="detalhe">
                                    {{ e.instituicao ? e.instituicao.nome : '' }}
                                </span>
                            </td>
                            <td class="u-text-center">{{ i.pontuacao }}</td>
                            <td class="u-text-center">{{ rotulo(i.situacao) }}</td>
                            <td class="u-text-center">{{ i.canal }}</td>
                            <td class="u-text-center acao">
                                <router-link v-if="podeEscrever" :to="'/admin/inscricao/edit/' + i.id" class="link-icon" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="9" class="u-text-center">Nenhuma inscrição encontrada.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12"><div class="u-text-left u-mt-10">Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.</div></el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                @current-change="irPara" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO D — itens 51 e 72: busca global de inscrições. */
export default {
    data: () => ({
        statusList: false,
        filtro: { nome: '', cpf: '', protocolo: '', situacao: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: [], situacoes: []
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/inscricao/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.situacoes = (r.data && r.data.situacoes) ? r.data.situacoes : [] }).catch(() => {})
        this.carregar()
    },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/inscricao/getAllPaginate?page=${this.paginate.page}`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => {
                this.items = r.data.data || []
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        irPara (p) { this.paginate.page = p; this.carregar() },
        rotulo (s) {
            const r = { inscrito: 'Inscrito', classificado: 'Classificado', encaminhado: 'Encaminhado',
                matriculado: 'Matriculado', indeferido: 'Indeferido', lista_espera: 'Lista de espera', cancelado: 'Cancelado' }
            return r[s] || s
        }
    }
}
</script>
<style scoped>.detalhe { display: block; font-size: 11px; color: #666; }</style>
